import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { LogOut, User } from 'lucide-react';

export function Header() {
  const { t } = useTranslation();
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header
      className="sticky top-0 z-50 w-full border-b border-bronze-800/20"
      style={{ background: 'linear-gradient(135deg, rgb(229, 184, 85) 0%, rgb(160, 106, 53) 50%, rgb(77, 48, 24) 100%)' }}
    >
      <div className="container flex h-14 items-center justify-between">
        {/* Links: Logo */}
        <Link to={isAuthenticated ? "/dashboard" : "/"} className="flex items-center">
          <span className="font-serif text-[28px] text-white">Antree</span>
        </Link>

        {/* Mitte: Dashboard (nur wenn eingeloggt, nur auf Desktop) */}
        {isAuthenticated && (
          <div className="hidden sm:block absolute left-1/2 -translate-x-1/2">
            <Link to="/dashboard">
              <Button variant="ghost" className="text-white hover:bg-black/20 hover:text-white">
                {t('nav.dashboard')}
              </Button>
            </Link>
          </div>
        )}

        {/* Rechts: Login/Logout */}
        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <>
              <span className="hidden sm:inline text-sm text-white/90">
                <User className="inline h-4 w-4 mr-1" />
                {user?.name}
              </span>
              <Button variant="ghost" size="icon" className="text-white hover:bg-white/20 hover:text-white" onClick={handleLogout}>
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" size="sm" className="text-white hover:bg-white/20 hover:text-white">
                  {t('auth:login.title', { ns: 'auth' })}
                </Button>
              </Link>
              <Link to="/register">
                <Button size="sm" className="bg-white text-bronze-700 hover:bg-white/90">
                  {t('auth:register.title', { ns: 'auth' })}
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
